import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

export default function GlobalAutoComplete({
  data = [],
  loading = false,
  label = '',
  keyName = { id: '', value: '' },
  sx = {},
  formikState = {
    formik: {},
    name: null,
  },
  setSelectValue = () => {},
  selectValue = null,
  disabled = false,
}) {
  const { id, value } = keyName;
  const { formik, name } = formikState;

  return (
    <Autocomplete
      disabled={disabled}
      sx={sx}
      options={data}
      loading={loading}
      isOptionEqualToValue={(opt, val) => opt?.[id] === val?.[id]}
      value={name ? formik?.values?.[name] : selectValue}
      onChange={(_, v) => {
        name ? formik?.setFieldValue(name, v) : setSelectValue(v);
      }}
      getOptionLabel={(opt) => opt?.[value] || ''}
      renderOption={(props, opt) => (
        <li {...props} key={opt?.[id]}>
          {opt?.[value]}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={name ? formik?.touched?.[name] && Boolean(formik?.errors?.[name]) : false}
          helperText={name ? formik?.touched?.[name] && formik?.errors?.[name] : ''}
        />
      )}
    />
  );
}
